import { render, staticRenderFns } from "./TotalPercent.vue?vue&type=template&id=4c7b2dee&"
import script from "./TotalPercent.vue?vue&type=script&lang=js&"
export * from "./TotalPercent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports